import { styled } from '@mui/material/styles';

/**
 * Visually hidden but still announced by screen readers. Used for SR-only
 * captions, breakdown summaries, and descriptive text behind icons/charts.
 * Shared across pages so accessibility primitives have one home.
 */
const VisuallyHidden = styled('span')({
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
});

export default VisuallyHidden;
